import {
  Box,
  CircularProgress,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

export default function StoreTopBar({
  search,
  onSearchChange,
  brands,
  selectedBrand,
  onBrandChange,
  selectedSectionName,
  loadingBrands,
}) {
  return (
    <Box
      sx={{
        mb: { xs: 2, md: 2.2 },
        p: { xs: 1.25, md: 1.5 },
        borderRadius: "24px",
        bgcolor: "#ffffff",
        border: "1px solid rgba(0,0,0,0.08)",
        boxShadow: "0 10px 28px rgba(0,0,0,0.04)",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "minmax(0,1fr) 240px" },
          gap: 1.1,
          alignItems: "center",
          mb: { xs: 0, lg: 1.15 },
        }}
      >
        <TextField
          fullWidth
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          size="small"
          placeholder="Buscar productos, marcas o categorías..."
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 48,
              borderRadius: "15px",
              bgcolor: "#ffffff",
            },
            "& .MuiInputBase-input": {
              fontSize: 14,
              fontWeight: 500,
              textAlign: "left",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: "#777777", fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          select
          fullWidth
          value={selectedBrand ?? ""}
          onChange={(e) => onBrandChange(e.target.value)}
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 48,
              borderRadius: "15px",
              bgcolor: "#ffffff",
            },
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              fontSize: 14,
              fontWeight: 500,
              textAlign: "left",
            },
          }}
          SelectProps={{
            displayEmpty: true,
            renderValue: (value) => {
              if (loadingBrands) {
                return "Cargando marcas...";
              }

              if (!value) {
                return "Todas las marcas";
              }

              const activeBrand = brands.find(
                (brand) => String(brand.id) === String(value)
              );

              return activeBrand?.name || "Todas las marcas";
            },
            MenuProps: {
              disableScrollLock: true,
              PaperProps: {
                sx: {
                  mt: 0.6,
                  borderRadius: "16px",
                  border: "1px solid rgba(0,0,0,0.08)",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.10)",
                  overflow: "hidden",
                  maxHeight: 320,
                  "& .MuiMenuItem-root": {
                    fontSize: 14,
                    fontWeight: 500,
                    minHeight: 42,
                    alignItems: "flex-start",
                    textAlign: "left",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: 1.35,
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="">
            {loadingBrands ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                }}
              >
                <CircularProgress size={16} thickness={5} sx={{ color: "#111111" }} />
                <Box component="span">Cargando marcas...</Box>
              </Box>
            ) : (
              "Todas las marcas"
            )}
          </MenuItem>

          {brands.map((brand) => (
            <MenuItem key={brand.id} value={brand.id}>
              {brand.name}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <Box
        sx={{
          display: { xs: "none", lg: "flex" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          pt: 0.1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: { md: 26, xl: 30 },
              fontWeight: 800,
              color: "#111111",
              lineHeight: 1.05,
              mb: 0.25,
              textAlign: "left",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {selectedSectionName || "Todos los productos"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}